import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import ErrorBoundary from '@wix/da-shared-react/pkg/ErrorBoundary';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';

import { SubSubNavBarProps } from './types';
import SubSubNavBarMobile from './Mobile';
import SubSubNavBarDesktop from './Desktop';
import { isViewingAsVisitor } from '../../selectors/users';

const SubSubNavBar: React.FC<SubSubNavBarProps> = props => {
  const isMobile = useContext(MobileContext);
  const asVisitor = useSelector(isViewingAsVisitor);

  return (
    <ErrorBoundary hideOnFail debugComponent="SubSubNavBar">
      {isMobile ? (
        <SubSubNavBarMobile {...props} isViewingAsVisitor={asVisitor} />
      ) : (
        <SubSubNavBarDesktop {...props} isViewingAsVisitor={asVisitor} />
      )}
    </ErrorBoundary>
  );
};
SubSubNavBar.displayName = 'SubSubNavBar';

export default SubSubNavBar;
